import { render, staticRenderFns } from "./_courses.vue?vue&type=template&id=621873b3&"
import script from "./_courses.vue?vue&type=script&lang=js&"
export * from "./_courses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports